var h = Object.freeze, y = Object.defineProperty;
var l = (t, r) => h(y(t, "raw", { value: h(r || t.slice()) }));
import { L as v } from "./lds-form-element-0ncM0Cyi.js";
import { i as k, x as p } from "./lit-element-CwWchyls.js";
import { n as o } from "./property-EvzlnPW3.js";
import { r as g } from "./state-D88UmDIj.js";
import { e as x } from "./query-Dk6NwgU8.js";
import { o as $ } from "./if-defined-BopGAQiw.js";
import "./lds-icon.js";
import { e as E } from "./class-map-CiBNip0q.js";
var u;
const w = k(u || (u = l(["\n    :host {\n        display: inline-block;\n    }\n\n    input {\n        position: absolute;\n        opacity: 0;\n        padding: 0;\n        margin: 0;\n        pointer-events: none;\n    }\n\n    label,\n    .wrapper {\n        position: relative;\n        display: inline-flex;\n        align-items: flex-start;\n        vertical-align: middle;\n        cursor: pointer;\n    }\n\n    .wrapper.disabled label,\n    .wrapper.disabled {\n        cursor: not-allowed;\n    }\n\n    .label.has-error {\n        color: var(--lds-color-error);\n    }\n\n    input:disabled {\n        cursor: not-allowed;\n    }\n\n    .control {\n        background-color: var(--lds-color-default-20);\n        border-radius: var(--lds-input-border-radius);\n        width: var(--lds-checkbox-size);\n        height: var(--lds-checkbox-size);\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n        border-color: transparent;\n    }\n\n    .disabled .control,\n    .disabled .readonly {\n        opacity: var(--lds-disabled-opacity);\n    }\n\n    .control.checked {\n        background-color: var(--lds-color-primary);\n        color: var(--lds-text-invert);\n    }\n\n    .label {\n        margin-inline-start: 0.5em;\n        line-height: var(--lds-checkbox-size);\n    }\n\n    .has-error {\n        border-color: var(--lds-color-error);\n    }\n"])));
var S = Object.defineProperty, i = (t, r, n, O) => {
  for (var s = void 0, a = t.length - 1, c; a >= 0; a--)
    (c = t[a]) && (s = c(r, n, s) || s);
  return s && S(r, n, s), s;
}, b, f;
const d = class d extends v {
  constructor() {
    super(...arguments), this.value = "", this.name = void 0, this.disabled = !1, this.readonly = !1, this.required = !1, this.checked = !1, this.hasError = !1, this.role = "checkbox";
  }
  get validationElement() {
    return this.input;
  }
  get formValue() {
    var r;
    return this.checked ? (r = this.value) != null ? r : "on" : null;
  }
  render() {
    return p(f || (f = l([' <div class="wrapper ', '" part="wrapper" @click=', '>\n            <input\n                type="checkbox"\n                part="input"\n                id="input"\n                .value=', "\n                ?disabled=", "\n                ?readonly=", "\n                ?required=", "\n                ?checked=", "\n                name=", '\n                aria-hidden="true" />\n            <div\n                class="control', '">\n                ', '\n            </div>\n            <label part="label" class="label ', '">\n                <slot></slot>\n            </label>\n        </div>'])), this.disabled ? "disabled" : "", this.onClick, this.value, this.disabled, this.readonly, this.required, this.checked, $(this.name), E({
      "has-error": this.hasError,
      checked: this.checked
    }), this.checked ? p(b || (b = l(['<lds-icon name="check" part="checked"></lds-icon>']))) : "", this.hasError ? "has-error" : "");
  }
  onClick() {
    this.disabled || this.readonly || (this.checked = !this.checked, this.emit("change", { checked: this.checked }));
  }
  updated(r) {
    if (!this.ranFirstUpdatedCycle) {
      this.ranFirstUpdatedCycle = !0;
      return;
    }
    super.updated(r), r.has("checked") && (this.updateForm(), this.hasError = !this.checkValidity());
  }
};
d.styles = w;
let e = d;
i([
  o()
], e.prototype, "value");
i([
  x("input")
], e.prototype, "input");
i([
  o({ type: String })
], e.prototype, "name");
i([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "disabled");
i([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "readonly");
i([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "required");
i([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "checked");
i([
  g()
], e.prototype, "hasError");
i([
  o({ type: String, reflect: !0 })
], e.prototype, "role");
const m = new URL(import.meta.url), V = m.searchParams.has("debug");
if (!m.searchParams.has("no-define")) {
  const t = customElements.get("lds-checkbox");
  t ? t.VERSION !== e.VERSION && V && console.log("%clds-checkbox tried loading in version ".concat(e.VERSION, ", but lds-checkbox is already defined as ").concat(t.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-checkbox", e);
}
export {
  e as LdsCheckbox
};
